'use client';
import React from 'react';

import Highlighter from 'react-highlight-words';

// import EditInAdminButton from '../EditInAdminButton';
import EmployeeActions from '../EmployeeActions';
import { ArticleItemWrap, ArticleIconWrap, Content, Title, Description } from './index.styled';
import ProductBadges from './ProductBadges';
import { sanitizeTitle, sanitizeDescription, processSearchExpression } from './sanitizationUtils';
import { customFindChunks } from './textProcessingUtils';
import { ArticleItemProps } from './types';
import { sanitizeHref } from './urlUtils';
import Icon from '@/ui/components/Icon';
import Link from '@/ui/components/Link';
import { log } from '@/utils/logger';

// const getFirstWords = (text: string) => {
//   const textWithoutTags = text.replace(/<[^>]*>/g, '');
//   const textWithoutSpecialChars = textWithoutTags.replace(/[^a-zA-Z0-9 ]/g, '');
//   const firstWords = textWithoutSpecialChars.split(' ').slice(0, 3);
//   return firstWords ? firstWords.join(' ') : '';
// };

// const linkWithScrollToText = ({
//   href,
//   text,
// }: {
//   href: string;
//   text: string | undefined;
// }) => {
//   if (!text) {
//     return href;
//   }

//   const firstWordsString = getFirstWords(text);

//   if (firstWordsString) {
//     // custom alt to #:~:tex=
//     return `${href}#text${encodeURIComponent(firstWordsString)}`;
//   }

//   return href;
// };

export default function SearchResultItem({
  href,
  title,
  description,
  noBorder = false,
  searchExpression,
  productSlugs,
  products,
}: ArticleItemProps) {
  const wordsToHighlight = React.useMemo(() => {
    return processSearchExpression(searchExpression);
  }, [searchExpression]);

  const processedTitle = React.useMemo(() => {
    return sanitizeTitle(title);
  }, [title]);

  const processedDescription = React.useMemo(() => {
    return sanitizeDescription(description);
  }, [description]);

  const sanitizedHref = React.useMemo(() => {
    return sanitizeHref(href);
  }, [href]);

  if (!title || !sanitizedHref) {
    log.error(`[SearchResultItem] Missing title or href. title: ${title} url: ${sanitizedHref} href: ${href}`);
    return null;
  }

  return (
    <ArticleItemWrap compact noBorder={noBorder}>
      <EmployeeActions href={sanitizedHref} title={title} description={description} />

      <ArticleIconWrap>
        <Link href={sanitizedHref}>
          {/* linkWithScrollToText({ href, text: description }) */}
          {sanitizedHref.includes('pdf') ? <Icon name="file-pdf" size="2xl" /> : <Icon name="file-lines" size="2xl" />}
        </Link>
      </ArticleIconWrap>

      <Content>
        <Title variant="h5" component="h3">
          <Link href={sanitizedHref}>
            <Highlighter
              highlightClassName="YourHighlightClass"
              searchWords={wordsToHighlight}
              autoEscape={true}
              textToHighlight={processedTitle}
              findChunks={customFindChunks}
              highlightStyle={{ background: 'transparent' }}
            />
          </Link>
        </Title>

        <Description>
          <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={wordsToHighlight}
            autoEscape={true}
            textToHighlight={processedDescription}
            highlightStyle={{ background: 'transparent' }}
            findChunks={customFindChunks}
          />
        </Description>

        <ProductBadges productSlugs={productSlugs} products={products} title={title} />
      </Content>
    </ArticleItemWrap>
  );
}
